<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/utils';

/**
 * Horizontal definition list for inspector detail rows.
 *
 * Each {@link InspectorDetailRow} child is a self-contained flex row (label
 * left, value right), so this wrapper just stacks them vertically:
 *
 * ```vue
 * <InspectorDetailList>
 *   <InspectorDetailRow label="File name">
 *     <span class="font-mono break-all">{{ fileName }}</span>
 *   </InspectorDetailRow>
 * </InspectorDetailList>
 * ```
 *
 * Because the row owns its own layout, labels no longer share a single column
 * width across the list — that's the accepted trade for one shared row
 * component. The `class` passthrough still tunes per-list spacing (e.g. the
 * popover's tighter gaps).
 */
const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <dl :class="cn('flex flex-col gap-y-2', props.class)">
    <slot />
  </dl>
</template>
